import { render, staticRenderFns } from "./EditGroupQuestion.vue?vue&type=template&id=7fc405af"
import script from "./EditGroupQuestion.vue?vue&type=script&lang=js"
export * from "./EditGroupQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports